import type { FlowsView } from "../../enums/scan";
import { FLOWS_VIEW } from "../../enums/scan";
import type { CandidateJourney } from "./journeyTypes";

export function estateRouteFocusProps(
  view: FlowsView,
  path: CandidateJourney | null,
): {
  routeFocusActive?: boolean;
  focusedPageIds?: string[];
  focusedLinks?: CandidateJourney["links"];
} {
  if (view !== FLOWS_VIEW.PATHS || !path) return {};
  return {
    routeFocusActive: true,
    focusedPageIds: path.steps.map((step) => step.page.id),
    focusedLinks: path.links,
  };
}
